import React, { useState } from "react";
import Chat from "./Chat";

const ChatSidebar =  (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);

  const styles = {
    sidebarContainer: {
      position: "fixed",
      bottom: 0,
      right: 0,
      height: isOpen ? "100vh" : "48px",
      width: isOpen ? "360px" : "48px",
      backgroundColor: "#5A954A",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
      borderRadius: isOpen ? "0" : "12px 12px 0 0",
      transition: "width 0.3s ease, height 0.3s ease, border-radius 0.3s ease",
      display: "flex",
      flexDirection: "column",
      zIndex: 1000,
      overflow: "hidden",
    },
    toggleButton: {
      height: "48px",
      width: "48px",
      backgroundColor: window._env_.Color1,
      border: "none",
      color: "#fff",
      fontSize: "1.5rem",
      cursor: "pointer",
      outline: "none",
      borderRadius: "12px 12px 0 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      userSelect: "none",
      flexShrink: 0,
    },
    chatWrapper: {
      flex: 1,
      display: isOpen ? "flex" : "none",
      flexDirection: "column",
      height: "100%",
      backgroundColor: "#5A954A",
    },
    header: {
      height: "48px",
      backgroundColor: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 12px",
      borderBottom: "1px solid #ccc",
      flexShrink: 0,
    },
    logo: {
      height: "24px",
      width: "auto",
    },
    closeButton: {
      background: "none",
      border: "none",
      fontSize: "1.2rem",
      cursor: "pointer",
      color: "#333",
      padding: "4px 8px",
    },
  };

  return (
    <div style={styles.sidebarContainer}>
      {!isOpen ? (
        <button
          aria-label="Open Chat Sidebar"
          title="Open Chat"
          onClick={toggleSidebar}
          style={styles.toggleButton}
        >
          💬
        </button>
      ) : (
        <>
          <div style={styles.header}>
            <button
              onClick={toggleSidebar}
              aria-label="Close Chat Sidebar"
              title="Close Chat"
              style={styles.closeButton}
            >
              ×
            </button>
          </div>
          <div style={styles.chatWrapper}>
            <Chat setSelectedTabIndex={props.setSelectedTabIndex}/>
          </div>
        </>
      )}
    </div>
  );
};

export default ChatSidebar;
